module.exports = __webpack_public_path__ + "img/offers.f32e7194.svg";